const isT1Image = imageSrc => imageSrc?.toLowerCase()?.includes('-t1-');

export default isT1Image;
